<template>
    <div>
        <h4 style="margin-top:0;">Demandes d'avis</h4>

        <div v-if="componentIsReady" style="display: flex; align-items: center; gap: 24px;">
            <img :src="avisVerifiesSrc" alt="Logo Avis Vérifiés" style="width:120px;"/>

            <div class="form-group" style="margin: 0;">
                <label style="margin: 0;">{{ fieldConfig.label }}</label>

                <custom-switch :field="fieldConfig" 
                    :value="!order.disable_avis_verifies"
                    field_idx="disable-avis-verifies"
                    @field-updated="toggleDisableAvisVerifies"
                    :as_number="false">
                </custom-switch>
            </div>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script>
    import {mapState} from "vuex"
    import CustomSwitch from "components/Forms/Elements/Switch"
    import ComponentLoader from "components/ComponentLoader"

    export default {
        data() {
            return {
                componentIsReady: false,
                currentDemand: null,
                order: null,
                avisVerifiesSrc: __API_URL__ + '/images/internal_purchase_tunnel/FR-AvisVerifies-Logo2.svg',
                fieldConfig: {
                    type: 'switch',
                    label: "Envoyer la demande d'avis",
                    model: "disable_avis_verifies",
                    default: false,
                    disabled: false,
                    help: "",
                    hint: ""
                }
            }
        },

        components: {
            CustomSwitch,
            ComponentLoader
        },

        mounted() {
            this.fetchOrder()
        },

        computed:{
            ...mapState('demands', ['current_demands'])
        },

        methods: {
            fetchOrder() {
                this.componentIsReady = false
                this.setCurrentDemand()

                if (this.currentDemand && this.currentDemand.validation_requestable.order_id) {
                    return this.axios
                        .get(`orders/${this.currentDemand.validation_requestable.order_id}`)
                        .then(response => {
                            this.order = response.data.order
                            this.componentIsReady = true
                        })
                } else {
                    console.log('No valid demand or validation_requestable found')
                }
            },

            setCurrentDemand() {
                if (this.currentDemand === null) {
                    this.currentDemand = _.find(this.current_demands, (demand) => demand.id == this.$route.params.id)
                }
            },

            toggleDisableAvisVerifies() {
                this.componentIsReady = false

                this.axios.put(`orders/${this.currentDemand.validation_requestable.order_id}/toggle_disable_avis_verifies`)
                    .then((response) => {
                        this.fetchOrder()
                    })
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Demands/ReviewRequestsTab.vue